import React from 'react';
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  CircularProgress
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import useStyles from './styles';
import useActivityLogs from '@dyl/hooks/useActivityLogs';
import quickDateFormat from '@dyl/utils/quickDateFormat';

const HistoryLog = ({ isChangeMode }) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(1);
  const itemsPerPage = 7;

  // Fetch activity logs from API
  const { records, loading } = useActivityLogs('arc_template', 'arc_template', true, isChangeMode);

  const totalPages = Math.ceil(records.length / itemsPerPage);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const historyData = records.slice(startIndex, endIndex);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset page
  };

  return (
    <Box className={classes.historyContainer}>
      <Typography gutterBottom className={`${classes.titleh1} ${classes.historyTitle}`}>
        History / log
      </Typography>
      <Typography variant="body1" gutterBottom className={`${classes.historyBody}`} sx={{ fontSize: '16px', fontWeight: 400, fontFamily: 'Roboto' }}>
        Below you can see a list of the previous templates used for the ARC Automarker. To change the active template, click on the 'Change' button next to the Active template above. In order to know the attributes of a template (.JSON file), the Admin needs to check with the ARC team. DO NOT change task templates when Live tests are in progress.
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer style={{ paddingRight: 0, maxWidth: '900px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeaderCell} style={{ width: '180px' }}>
                    Date
                  </TableCell>
                  <TableCell className={classes.tableHeaderCellWithPadding} style={{ width: '304px' }}>
                    User
                  </TableCell>
                  <TableCell className={classes.tableHeaderCellWithPadding} style={{ width: '200px' }}>
                    Template name
                  </TableCell>
                  <TableCell className={classes.tableHeaderCellWithPadding}>
                    Version
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {historyData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell className={classes.tableDataCell} style={{ width: '180px' }}>
                      {quickDateFormat(row.created_at)}
                    </TableCell>
                    <TableCell className={classes.tableDataCellWithPadding} style={{ width: '304px' }}>
                      {row.user_name}
                    </TableCell>
                    <TableCell className={classes.tableDataCellWithPadding} style={{ width: '200px' }}>
                      {row.template_name}
                    </TableCell>
                    <TableCell className={classes.tableDataCellWithPadding}>
                      {row.template_version}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
            <TablePagination
              sx={{ width: '900px', display: 'flex', justifyContent: 'flex-end' }}
              component="div"
              count={records.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20,50,100]}
            />
        </>
      )}
    </Box>
  );
};

export default HistoryLog;
